// extracted by mini-css-extract-plugin
module.exports = {"textSlot":"DropdownMenu-module__textSlot___gr66m","items":"DropdownMenu-module__items___DuB7Q","divider":"DropdownMenu-module__divider___OaP32"};